/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_SALES_INVOICE = `${url}/LOAD_SALES_INVOICE`;
export const LOAD_SALES_INVOICE_SUCCESS = `${url}/LOAD_SALES_INVOICE_SUCCESS`;
export const LOAD_SALES_INVOICE_ERROR = `${url}/LOAD_SALES_INVOICE_ERROR`;
export const LOAD_CREDIT_NOTE_LIST = `${url}/LOAD_CREDIT_NOTE_LIST`;
export const LOAD_CREDIT_NOTE_LIST_SUCCESS = `${url}/LOAD_CREDIT_NOTE_LIST_SUCCESS`;
export const LOAD_CREDIT_NOTE_LIST_ERROR = `${url}/LOAD_CREDIT_NOTE_LIST_ERROR`;
export const LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION = `${url}/LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION`;
export const LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_SUCCESS = `${url}/LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_SUCCESS`;
export const LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_ERROR = `${url}/LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_ERROR`;

export const LOAD_SALES_TOTAL = `${url}/LOAD_SALES_TOTAL`;
export const LOAD_SALES_TOTAL_SUCCESS = `${url}/LOAD_SALES_TOTAL_SUCCESS`;
export const LOAD_SALES_TOTAL_ERROR = `${url}/LOAD_SALES_TOTAL_ERROR`;

export const LOAD_TOTAL_SALES_PAID = `${url}/LOAD_TOTAL_SALES_PAID`;
export const LOAD_TOTAL_SALES_PAID_SUCCESS = `${url}/LOAD_TOTAL_SALES_PAID_SUCCESS`;
export const LOAD_TOTAL_SALES_PAID_ERROR = `${url}/LOAD_TOTAL_SALES_PAID_ERROR`;
export const LOAD_TOTAL_SALES_UNPAID = `${url}/LOAD_TOTAL_SALES_UNPAID`;
export const LOAD_TOTAL_SALES_UNPAID_SUCCESS = `${url}/LOAD_TOTAL_SALES_UNPAID_SUCCESS`;
export const LOAD_TOTAL_SALES_UNPAID_ERROR = `${url}/LOAD_TOTAL_SALES_UNPAID_ERROR`;

export const CREATE_SALES_INVOICE = `${url}/CREATE_SALES_INVOICE`;
export const CREATE_SALES_INVOICE_SUCCESS = `${url}/CREATE_SALES_INVOICE_SUCCESS`;
export const CREATE_SALES_INVOICE_ERROR = `${url}/CREATE_SALES_INVOICE_ERROR`;
export const LOAD_SEARCH_IMEI_BARCODE = `${url}/LOAD_SEARCH_IMEI_BARCODE`;
export const LOAD_SEARCH_IMEI_BARCODE_SUCCESS = `${url}/LOAD_SEARCH_IMEI_BARCODE_SUCCESS`;
export const LOAD_SEARCH_IMEI_BARCODE_ERROR = `${url}/LOAD_SEARCH_IMEI_BARCODE_ERROR`;

//category
export const LOAD_SALES_INVOICE_CATEGORY = `${url}/LOAD_SALES_INVOICE_CATEGORY`;
export const LOAD_SALES_INVOICE_CATEGORY_SUCCESS = `${url}/LOAD_SALES_INVOICE_CATEGORY_SUCCESS`;
export const LOAD_SALES_INVOICE_CATEGORY_ERROR = `${url}/LOAD_SALES_INVOICE_CATEGORY_ERROR`;

export const CREATE_SALES_INVOICE_PARTIES_CATEGORY = `${url}/CREATE_SALES_INVOICE_PARTIES_CATEGORY`;
export const CREATE_SALES_INVOICE_PARTIES_CATEGORY_SUCCESS = `${url}/CREATE_SALES_INVOICE_PARTIES_CATEGORY_SUCCESS`;
export const CREATE_SALES_INVOICE_PARTIES_CATEGORY_ERROR = `${url}/CREATE_SALES_INVOICE_PARTIES_CATEGORY_ERROR`;

export const UPDATE_SALES_INVOICE = `${url}/UPDATE_SALES_INVOICE`;
export const UPDATE_SALES_INVOICE_SUCCESS = `${url}/UPDATE_SALES_INVOICE_SUCCESS`;
export const UPDATE_SALES_INVOICE_ERROR = `${url}/UPDATE_SALES_INVOICE_ERROR`;

export const DELETE_SALES_INVOICE = `${url}/DELETE_SALES_INVOICE`;
export const DELETE_SALES_INVOICE_SUCCESS = `${url}/DELETE_SALES_INVOICE_SUCCESS`;
export const DELETE_SALES_INVOICE_ERROR = `${url}/DELETE_SALES_INVOICE_ERROR`;

export const LOAD_SALES_INVOICE_RECORDS_META_DATA = `${url}/LOAD_SALES_INVOICE_RECORDS_META_DATA`;
export const LOAD_SALES_INVOICE_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_SALES_INVOICE_RECORDS_META_DATA_SUCCESS`;
export const LOAD_SALES_INVOICE_RECORDS_META_DATA_ERROR = `${url}/LOAD_SALES_INVOICE_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_PARTIES_TRANSACTION = `${url}/LOAD_PARTIES_TRANSACTION`;
export const LOAD_PARTIES_TRANSACTION_SUCCESS = `${url}/LOAD_PARTIES_TRANSACTION_SUCCESS`;
export const LOAD_PARTIES_TRANSACTION_ERROR = `${url}/LOAD_PARTIES_TRANSACTION_ERROR`;

// address update
export const LOAD_PARTY_VENDOR_ADDRESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_ERROR = `${url}/LOAD_PARTY_VENDOR_ADDRESS_ERROR`;

export const CREATE_PARTY_VENDOR_ADDRESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_ERROR = `${url}/CREATE_PARTY_VENDOR_ADDRESS_ERROR`;

const constants = {
  LOAD_SALES_INVOICE,
  LOAD_SALES_INVOICE_SUCCESS,
  LOAD_SALES_INVOICE_ERROR,
  LOAD_CREDIT_NOTE_LIST,
  LOAD_CREDIT_NOTE_LIST_SUCCESS,
  LOAD_CREDIT_NOTE_LIST_ERROR,
  LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION,
  LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_SALES_INVOICE_DASHBOARD_TRANSACTION_ERROR,
  LOAD_SALES_TOTAL,
  LOAD_SALES_TOTAL_SUCCESS,
  LOAD_SALES_TOTAL_ERROR,
  LOAD_TOTAL_SALES_PAID,
  LOAD_TOTAL_SALES_PAID_SUCCESS,
  LOAD_TOTAL_SALES_PAID_ERROR,
  LOAD_TOTAL_SALES_UNPAID,
  LOAD_TOTAL_SALES_UNPAID_SUCCESS,
  LOAD_TOTAL_SALES_UNPAID_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,

  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,

  LOAD_SALES_INVOICE_CATEGORY,
  LOAD_SALES_INVOICE_CATEGORY_SUCCESS,
  LOAD_SALES_INVOICE_CATEGORY_ERROR,

  CREATE_SALES_INVOICE_PARTIES_CATEGORY,
  CREATE_SALES_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_SALES_INVOICE_PARTIES_CATEGORY_ERROR,

  CREATE_SALES_INVOICE,
  CREATE_SALES_INVOICE_SUCCESS,
  CREATE_SALES_INVOICE_ERROR,

  LOAD_SEARCH_IMEI_BARCODE,
  LOAD_SEARCH_IMEI_BARCODE_SUCCESS,
  LOAD_SEARCH_IMEI_BARCODE_ERROR,

  UPDATE_SALES_INVOICE,
  UPDATE_SALES_INVOICE_SUCCESS,
  UPDATE_SALES_INVOICE_ERROR,

  DELETE_SALES_INVOICE,
  DELETE_SALES_INVOICE_SUCCESS,
  DELETE_SALES_INVOICE_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_SALES_INVOICE_RECORDS_META_DATA,
  LOAD_SALES_INVOICE_RECORDS_META_DATA_SUCCESS,
  LOAD_SALES_INVOICE_RECORDS_META_DATA_ERROR,
};

export default constants;
